import { useEffect, useState } from "react";
import DialogInfoGeneral from "./DialogInfoGeneral";
import process from "process";
import { HiArrowPath, HiSparkles } from "react-icons/hi2";

function VersionCheck() {
  const [showUpdateNotification, setShowUpdateNotification] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdate = () => {
    setIsUpdating(true);
    try{
      localStorage.setItem("isf_version", process?.env?.REACT_APP_VERSION || "");
    }catch(e){
      console.error('no fue posible almacenar versión',e)
    }
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };


  useEffect(() => {
    const version = process?.env?.REACT_APP_VERSION;

    if (version) {
      try {
        const storedVersion = localStorage.getItem("isf_version");

        if (storedVersion !== version) {
          setShowUpdateNotification(true);
        }
        if(!storedVersion){
          handleUpdate()
        }
      } catch (error) {
        console.error("Error accessing localStorage:", error);
      }
    } else {
      console.warn("REACT_APP_VERSION is undefined.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <DialogInfoGeneral
        show={showUpdateNotification}
        closeDialog={() => {}}
        disabledClosable={true}
        disabledFooter={true}
        size="xl:w-1/3"
      >
        <div className="relative overflow-hidden">
          {/* Background gradient decoration */}
          <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-br from-[#0048b5] via-blue-600 to-blue-500 opacity-10"></div>
          
          <div className="relative py-8 px-8">

            {/* Icon and animation */}
            <div className="flex justify-center mb-6">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-br from-[#0048b5] to-blue-600 rounded-full blur-xl opacity-30 animate-pulse"></div>
                <div className="relative w-20 h-20 bg-gradient-to-br from-[#0048b5] to-blue-600 rounded-full flex items-center justify-center shadow-lg">
                  {isUpdating ? (
                    <HiArrowPath className="text-white text-3xl animate-spin" />
                  ) : (
                    <HiSparkles className="text-white text-3xl" />
                  )}
                </div>
              </div>
            </div>

            {/* Title */}
            <div className="text-center mb-4">
              <h2 className="text-2xl font-bold text-gray-800 mb-2">
                ¡Nueva Versión Disponible!
              </h2>
              <p className="text-gray-600 text-base leading-relaxed">
                Hemos mejorado la aplicación con nuevas características y correcciones importantes.
              </p>
            </div>

            {/* Benefits list */}
            <div className="bg-blue-50 rounded-lg p-4 mb-6 border border-blue-100">
              <div className="space-y-2 text-sm text-gray-700">
                <div className="flex items-center gap-2">
                  <div className="w-1.5 h-1.5 bg-[#0048b5] rounded-full"></div>
                  <span>Mejoras de rendimiento</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-1.5 h-1.5 bg-[#0048b5] rounded-full"></div>
                  <span>Nuevas funcionalidades</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-1.5 h-1.5 bg-[#0048b5] rounded-full"></div>
                  <span>Corrección de errores</span>
                </div>
              </div>
            </div>

            {/* Action buttons */}
            <div className="flex items-center justify-center">
              <button
                onClick={handleUpdate}
                disabled={isUpdating}
                className="w-full sm:w-auto flex items-center justify-center gap-2 bg-gradient-to-r from-[#0048b5] via-[#003a8f] to-[#002d6b] hover:from-[#003a8f] hover:via-[#002d6b] hover:to-[#002050] text-white font-semibold px-8 py-3 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98] disabled:opacity-70 disabled:cursor-not-allowed disabled:transform-none"
              >
                {isUpdating ? (
                  <>
                    <HiArrowPath className="animate-spin" size={20} />
                    <span>Actualizando...</span>
                  </>
                ) : (
                  <>
                    <HiArrowPath size={20} />
                    <span>Actualizar Ahora</span>
                  </>
                )}
              </button>
            </div>

            {/* Footer note */}
            {!isUpdating && (
              <p className="text-xs text-gray-500 text-center mt-6">
                La actualización tomará solo unos segundos
              </p>
            )}
          </div>
        </div>
      </DialogInfoGeneral>
    </div>
  );
}

export default VersionCheck;